import React from 'react';
import { IconContainer } from './IconContainer';

const CheckIcon = (props) => {
    return (
        <IconContainer active ariaLabel="check" cursor="pointer" {...props}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.2499 9.9122L12.8327 1.5L14 2.7939L5.2499 12.5L0 6.67652L1.16646 5.38262L5.2499 9.9122Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { CheckIcon };